import * as React from "react";
const SvgPause20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M3 2H2v16h7V2H3Zm1 14V4h3v12H4Zm8-14h-1v16h7V2h-6Zm1 14V4h3v12h-3Z",
      clipRule: "evenodd"
    })
  );
export default SvgPause20Px;
